<template>
  <div class="my-12 py-12">
    <v-row no-gutters class="flex-row justify-space-between">
      <v-col cols="7">
        <v-card flat>
          <v-carousel
            cycle
            height="500"
            hide-delimiters
            :show-arrows="false"
            v-model="selected"
          >
            <v-carousel-item
              v-for="step in steps"
              :key="step.id"
              reverse-transition="fade-transition"
              transition="fade-transition"
            >
              <v-responsive :aspect-ratio="10 / 7">
                <v-img
                  :src="require(`../assets/${step.image}`)"
                  height="500px"
                />
              </v-responsive>
            </v-carousel-item>
          </v-carousel>
        </v-card>
      </v-col>
      <v-col cols="4" class="d-flex flex-column justify-space-between">
        <v-card
          v-for="step in steps"
          :key="step.title"
          @click="selected = step.id"
          :class="{ step: true, selected: selected == step.id }"
          outlined
        >
          <v-expansion-panels
            :value="maybeExpandStep(step.id)"
            flat
            class="no-padding"
          >
            <v-expansion-panel readonly :key="step.id">
              <v-expansion-panel-header>
                <template v-slot:actions>
                  <div></div>
                </template>
                <v-card-title class="d-flex align-start flex-column">
                  <span
                    :class="{
                      'primary-caption': selected == step.id,
                      caption: true,
                    }"
                    >{{ step.who }}</span
                  >
                  <span :class="{ 'primary-text': selected == step.id }">
                    {{ step.title }}
                  </span>
                </v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="body-2">
                {{ step.description }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "OverviewDesktop",
  props: ["steps"],
  data: () => {
    return {
      selected: 0,
    };
  },

  methods: {
    maybeExpandStep(stepId) {
      return this.selected === stepId ? 0 : 1;
    },
  },
};
</script>

<style scoped>
.step .selected-enter-active,
.step .selected-leave-active {
  transition: 500ms ease-in;
  transform: translate(0, -5px);
}
.selected {
  border-color: #f79406 !important;
}
.primary-text {
  color: #f79406;
}
.primary-caption {
  color: #f79406;
}
.v-expansion-panel-header {
  padding: 0px 8px 0px 8px;
}
.v-expansion-panel-content__wrap {
  padding: 0px !important;
}
</style>
